import { PButton, PHeading, PText } from '@porsche-design-system/components-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

export interface NotFoundProps {
    homePath?: string | null;
}

const NotFound = ({ homePath = '/' }: NotFoundProps) => {
    const navigate = useNavigate();
    const { t } = useTranslation('common');

    return (
        <div style={{ textAlign: 'center' }}>
            <PText align="center" color="inherit" inert={undefined} style={{ marginTop: '24px' }} weight="semi-bold">
                404
            </PText>
            <PHeading align="center" color="primary" inert={undefined} size="xx-large">
                {t('common:pages:404:title')}
            </PHeading>
            <PText align="center" color="inherit" inert={undefined} style={{ marginTop: '24px' }}>
                {t('common:pages:404:description')}
            </PText>
            {homePath && (
                <div
                    style={{
                        marginTop: '40px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        columnGap: '24px',
                    }}
                >
                    <PButton inert={undefined} onClick={() => navigate(homePath)} type="button">
                        {t('common:pages:404:buttonSpan')}
                    </PButton>
                </div>
            )}
        </div>
    );
};

export default NotFound;
